<template>
  <div class="content register-body">
    <div class="row m-0">
      <div class="col-lg-12 col-md-12 col-sm-12 top-logo">
        <router-link to="/">
          <img :src="logo" />
        </router-link>
      </div>
    </div>
    <div class="row content-body w-75">
      <div v-if="ShowStep1" class="col-lg-12 col-md-12 col-sm-12 my-4">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 my-4">
            <div class="d-grid">
              <label class="title">{{ $t("proprietaire_register.step1.title") }}</label>
            </div>
          </div>
        </div>
      

        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 mt-2 mb-4">
            <div class="d-grid w-75 mx-auto form-register">
              <div class="dropdown w-100 mb-2">
                <!-- Bouton comme un <select> -->
                <button
                  class="dropdown-toggle w-100 text-start"
                  :class="{ error: EmptyCivility }"
                  type="button"
                  @click="toggleDropdownCivility"
                >
                  {{ selectedCivility.name || $t("proprietaire_register.step1.placeholders.select_civility") }}
                </button>
                <!-- Menu déroulant avec recherche -->
                <div
                  class="dropdown-menu show w-100 p-2"
                  v-if="isOpenCivility"
                  style="max-height: 300px; overflow-y: auto"
                >
                  <input
                    type="text"
                    class="form-control mb-2"
                    :placeholder="$t('proprietaire_register.step1.placeholders.search_civility')"
                    v-model="searchCivility"
                    @click.stop
                  />
                  <button
                    v-for="civility in filteredCivilities"
                    :key="civility.val"
                    class="dropdown-item text-start"
                    @click="selectCivility(civility)"
                  >
                    {{ civility.name }}
                    <span v-if="selectedCivility.val === civility.val" class="ms-2 text-success">✔</span>
                  </button>
                </div>
              </div>
              <input
                type="text"
                v-model="user.lastname"
                class="input-text mb-2"
                :class="{ error: EmptyLastName }"
                :placeholder="$t('proprietaire_register.step1.placeholders.last_name')"
              />
              <input
                type="text"
                v-model="user.firstname"
                class="input-text mb-2"
                :class="{ error: EmptyFirstName }"
                :placeholder="$t('proprietaire_register.step1.placeholders.first_name')"
              />
              
              <!-- Champ email avec gestion du mode profil existant -->
              <div class="position-relative">
                <input
                  type="text"
                  v-model="user.email"
                  class="input-text w-100 mb-2"
                  :class="{ 
                    error: EmptyEmail,
                    'email-disabled': isExistingCustomer
                  }"
                  :placeholder="$t('proprietaire_register.step1.placeholders.email')"
                  :disabled="isExistingCustomer"
                />
                
              </div>
              <span v-if="errorValidEmail" class="error-message mb-4">{{ errorValidEmail }}</span>
              
              <input
                type="text"
                v-model="user.confirm_email"
                class="input-text mb-2"
                :class="{ 
                  error: EmptyConfirmEmail,
                  'email-disabled': isExistingCustomer
                }"
                :placeholder="$t('proprietaire_register.step1.placeholders.confirm_email')"
                :disabled="isExistingCustomer"
              />
              <span v-if="errorConfirmEmail" class="error-message mb-4">{{ errorConfirmEmail }}</span>
              
              <div class="info-prop d-grid mb-2">
                <label>{{ $t("proprietaire_register.step1.labels.veterinarian_is") }}</label>
                <b>{{ veterinaire.lastname }}</b>
                <label>{{ veterinaire.street }}</label>
                <label>{{ veterinaire.postcode }} {{ veterinaire.city }}</label>
              </div>
              <div class="form-check mb-2">
                <input
                  type="checkbox"
                  v-model="user.professionnel"
                  class="form-check-input"
                  id="professionnel"
                />
                <label class="form-check-label" for="professionnel">
                  {{ $t("proprietaire_register.step1.labels.is_professional") }}
                </label>
              </div>
              <input
                v-if="user.professionnel"
                type="text"
                v-model="user.numeroTva"
                class="input-text mb-2"
                :class="{ error: EmptyVatNumber }"
                :placeholder="$t('proprietaire_register.step1.placeholders.vat_number')"
              />
              <input
                v-if="user.professionnel"
                type="text"
                v-model="user.company"
                class="input-text mb-2"
                :class="{ error: EmptyCompany }"
                :placeholder="$t('proprietaire_register.step1.placeholders.company')"
              />
              
              <!-- Message d'information pour le mot de passe -->
              <div v-if="isExistingCustomer" class="password-info alert alert-warning mb-2">
                <small>
                  <strong>Mise à jour du mot de passe</strong><br />
                  Attention, en sélectionnant un mot de passe, vous allez également modifier celui de votre compte certivet.com
                </small>
              </div>
              
              <input
                type="password"
                v-model="user.password"
                class="input-text mb-2"
                :class="{ error: EmptyPassword }"
                :placeholder="$t('proprietaire_register.step1.placeholders.password')"
              />
              <input
                type="password"
                v-model="user.confirm_password"
                class="input-text mb-2"
                :class="{ error: EmptyConfirmPassword }"
                :placeholder="$t('proprietaire_register.step1.placeholders.confirm_password')"
              />
              <span v-if="errorConfirmPassword" class="error-message mb-4">{{ errorConfirmPassword }}</span>
              <button
                class="btn text-white btn-register w-100"
                id="step1"
                @click.prevent="RegisterStepOne"
                :disabled="isLoadingStepOne"
              >
                {{ isExistingCustomer ? 'Mettre à jour mon profil' : $t("proprietaire_register.step1.buttons.next_step") }}
              </button>
              <span v-if="errorMessage" class="error-message mt-4">{{ errorMessage }}</span>
            </div>
          </div>
          <div class="col-lg-1 col-md-1 col-sm-1"></div>
          <div class="col-lg-11 col-md-11 col-sm-11">
            <router-link to="/create-compte">
              <label class="prev-step">
                <img :src="prev" /> {{ $t("proprietaire_register.step1.links.previous_step") }}
              </label>
            </router-link>
          </div>
        </div>
      </div>
      <div v-if="ShowStep2" class="col-lg-12 col-md-12 col-sm-12 my-4">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 my-4">
            <div class="d-grid">
              <label class="title">{{ $t("proprietaire_register.step2.title") }}</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 mt-2">
            <div class="d-grid w-75 mx-auto form-register">
              <input
                type="text"
                v-model="user.street"
                class="input-text mb-2"
                :class="{ error: EmptyStreet }"
                :placeholder="$t('proprietaire_register.step2.placeholders.street')"
              />
              <input
                type="text"
                v-model="user.street2"
                class="input-text mb-2"
                :placeholder="$t('proprietaire_register.step2.placeholders.street2')"
              />
              <input
                type="text"
                v-model="user.postcode"
                v-only-digits
                class="input-text mb-2"
                :class="{ error: EmptyCodePostal }"
                :placeholder="$t('proprietaire_register.step2.placeholders.postcode')"
              />
              <input
                type="text"
                v-model="user.city"
                class="input-text mb-2"
                :class="{ error: EmptyCity }"
                :placeholder="$t('proprietaire_register.step2.placeholders.city')"
              />
              <div class="dropdown w-100 mb-2">
                <button
                  class="dropdown-toggle w-100 text-start"
                  :class="{ error: EmptyCountry }"
                  type="button"
                  @click="toggleDropdownCountry"
                >
                  {{ selectedCountry.name || $t("proprietaire_register.step2.placeholders.select_country") }}
                </button>
                <div
                  class="dropdown-menu show w-100 p-2"
                  v-if="isOpenCountry"
                  style="max-height: 300px; overflow-y: auto"
                >
                  <input
                    type="text"
                    class="form-control mb-2"
                    :placeholder="$t('proprietaire_register.step2.placeholders.search_country')"
                    v-model="searchCountry"
                    @click.stop
                  />
                  <button
                    v-for="country in filteredCountries"
                    :key="country.code"
                    class="dropdown-item text-start"
                    @click="selectCountry(country)"
                  >
                    {{ country.name }}
                    <span v-if="selectedCountry.code === country.code" class="ms-2 text-success">✔</span>
                  </button>
                </div>
              </div>
              <input
                type="text"
                v-model="user.phonenumber"
                v-only-digits
                class="input-text mb-2"
                :class="{ error: EmptyPhone }"
                :placeholder="$t('proprietaire_register.step2.placeholders.phone_mobile')"
              />
              <button
                class="btn text-white btn-register w-100 mb-4"
                id="step2"
                @click.prevent="ValidateRegister"
                :disabled="isLoadingStepTwo"
              >
                {{
                  isLoadingStepTwo
                    ? $t("proprietaire_register.loading.step_two")
                    : isExistingCustomer 
                      ? 'Finaliser la mise à jour'
                      : $t("proprietaire_register.step2.buttons.validate_registration")
                }}
              </button>
              <div v-if="infoMessage" class="alert alert-success">
                <span class="info-message mt-4">{{ infoMessage }}</span>
              </div>
            </div>
          </div>
          <div class="col-lg-1 col-md-1 col-sm-1"></div>
          <div class="col-lg-11 col-md-11 col-sm-11">
            <label class="prev-step" @click.prevent="PrevStep">
              <img :src="prev" /> {{ $t("proprietaire_register.step1.links.previous_step") }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCountries } from "@/api/auth";
import { registerProprietaire } from "@/api/auth";
import { useRegisterStore } from "@/stores/register";

import icon1 from "@/assets/images/icon_veterinaire.png";
import icon2 from "@/assets/images/icon_proprietaire.png";
import logo from "@/assets/images/2_LOGO - COULEURS-bg-b.png";
import prev from "@/assets/images/icon-prev.svg";

import $ from "jquery";

export default {
  name: "ProprietaireRegister",
  data() {
    return {
      icon1,
      icon2,
      logo,
      prev,
      error: null,
      ShowStep1: true,
      ShowStep2: false,
      countries: [],
      user: {
        civilite: "",
        firstname: "",
        lastname: "",
        email: "",
        confirm_email: "",
        code_clinique: "",
        confirm_code_clinique: "",
        street: "",
        street2: "",
        city: "",
        postcode: "",
        countrycode: "",
        phonenumber: "",
        step: 2,
        professionnel: false,
        numeroTva: "",
        company: "",
        password: "",
        confirm_password: "",
      },
      civilities: [
        { val: "M.", name: "Monsieur" },
        { val: "Mme", name: "Madame" },
        { val: "Mlle", name: "Mademoiselle" },
        { val: "AUTR", name: "Autres" },
      ],
      veterinaire: {},
      selectedCivility: "",
      isOpenCivility: false,
      searchCivility: "",
      selectedCountry: "",
      isOpenCountry: false,
      searchCountry: "",
      isLoadingStepOne: false,
      isLoadingStepTwo: false,
      infoMessage: "",
      errorMessage: "",
      EmptyCivility: false,
      EmptyLastName: false,
      EmptyFirstName: false,
      EmptyEmail: false,
      errorValidEmail: "",
      EmptyConfirmEmail: false,
      errorConfirmEmail: "",
      EmptyPassword: false,
      EmptyConfirmPassword: false,
      errorConfirmPassword: "",
      EmptyVatNumber: false,
      EmptyCompany: false,
      canStore: true,
      EmptyStreet: false,
      EmptyCodePostal: false,
      EmptyCity: false,
      EmptyCountry: false,
      EmptyPhone: false,
      canRegister: true,
      isExistingCustomer: false, 
      existingCustomerData: null, 
    };
  },
  mounted() {
    const store = useRegisterStore();
    this.user.email = store.user.email;
    this.user.code_clinique = store.user.code_clinique;
    this.veterinaire = store.VeterinaireInfo;
    
    // Appeler GetPays d'abord, puis checkExistingCustomer après le chargement des pays
    this.GetPays().then(() => {
      this.checkExistingCustomer();
    });
  },
  computed: {
    filteredCivilities() {
      const query = this.searchCivility.toLowerCase();
      return this.civilities.filter(
        (civility) =>
          civility.name.toLowerCase().includes(query) ||
          civility.val.toLowerCase().includes(query)
      );
    },
    filteredCountries() {
      const query = this.searchCountry.toLowerCase();
      return this.countries.filter((country) =>
        country.name.toLowerCase().includes(query)
      );
    },
  },
  watch: {
    'user.email': {
      handler(newEmail) {
        if (this.isExistingCustomer && newEmail) {
          // Synchroniser automatiquement l'email de confirmation
          this.$nextTick(() => {
            this.user.confirm_email = newEmail;
          });
        }
      },
      immediate: true
    },
    isExistingCustomer: {
      handler(newValue) {
        if (newValue && this.user.email) {
          // Quand le mode profil existant est activé, synchroniser les emails
          this.$nextTick(() => {
            this.user.confirm_email = this.user.email;
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    checkExistingCustomer() {
      const store = useRegisterStore();
    
      if (store.apiResponse && store.apiResponse.customer_exists === true) {
        this.isExistingCustomer = true;
        this.existingCustomerData = store.apiResponse;
        this.preFillFormData();
      }
      
      // Vérifier également le flag de profil existant en utilisant le getter
      if (store.isExistingCustomer) {
        this.isExistingCustomer = true;
        // S'assurer que l'email de confirmation est bien rempli
        if (store.user.email) {
          this.user.confirm_email = store.user.email;
        }
      }
      
      // S'assurer que l'email de confirmation est toujours synchronisé avec l'email principal
      if (this.user.email && !this.user.confirm_email) {
        this.user.confirm_email = this.user.email;
      }
    },
    
    preFillFormData() {
      if (!this.existingCustomerData) return;
      
      // Préremplir les champs avec les données de l'API
      const data = this.existingCustomerData;
      
      // Civilité
      if (data.civilite) {
        const civility = this.civilities.find(c => c.val === data.civilite);
        if (civility) {
          this.selectedCivility = civility;
          this.user.civilite = data.civilite;
        }
      }
      
      // Nom et prénom
      if (data.lastname) this.user.lastname = data.lastname;
      if (data.firstname) this.user.firstname = data.firstname;
      
      // Email (verrouillé) - FORCER la synchronisation des deux champs
      if (data.email) {
        this.user.email = data.email;
        this.user.confirm_email = data.email; // ← FORCER la valeur
      }
      
      // Informations professionnelles
      if (data.professionnel !== undefined) this.user.professionnel = data.professionnel;
      if (data.numeroTva) this.user.numeroTva = data.numeroTva;
      if (data.company) this.user.company = data.company;
      
      // Adresse de facturation
      if (data.facturation_exists && data.street) this.user.street = data.street;
      if (data.facturation_exists && data.street2) this.user.street2 = data.street2;
      if (data.facturation_exists && data.postcode) this.user.postcode = data.postcode;
      if (data.facturation_exists && data.city) this.user.city = data.city;
      if (data.facturation_exists && data.countrycode) {
        this.user.countrycode = data.countrycode;
        const country = this.countries.find(c => c.code === data.countrycode);
        if (country) this.selectedCountry = country;
      }
      if (data.phonenumber) this.user.phonenumber = data.phonenumber;
      
      // Forcer la synchronisation après un délai pour s'assurer que tout est chargé
      this.$nextTick(() => {
        if (this.user.email && (!this.user.confirm_email || this.user.confirm_email !== this.user.email)) {
          this.user.confirm_email = this.user.email;
        }
      });
    },
    
    PrevStep() {
      this.user.step = 2;
      this.ShowStep2 = false;
      this.ShowStep1 = true;
    },
    GetPays() {
      return new Promise((resolve) => {
        getCountries()
          .then((res) => {
            this.countries = res.data;
            this.checkExistingCustomer();
            resolve();
          })
          .catch(() => {
            this.checkExistingCustomer();
            resolve();
          });
      });
    },
    toggleDropdownCivility() {
      this.isOpenCivility = !this.isOpenCivility;
    },
    selectCivility(civility) {
      this.selectedCivility = civility;
      this.user.civilite = civility.val;
      this.isOpenCivility = false;
      this.searchCivility = "";
    },
    toggleDropdownCountry() {
      this.isOpenCountry = !this.isOpenCountry;
    },
    selectCountry(country) {
      this.selectedCountry = country;
      this.user.countrycode = country.code;
      this.isOpenCountry = false;
      this.searchCountry = "";
    },
    RegisterStepOne() {
      this.errorMessage = "";
      this.EmptyCivility = false;
      this.EmptyLastName = false;
      this.EmptyFirstName = false;
      this.EmptyEmail = false;
      this.errorValidEmail = "";
      this.EmptyConfirmEmail = false;
      this.errorConfirmEmail = "";
      this.EmptyPassword = false;
      this.EmptyConfirmPassword = false;
      this.errorConfirmPassword = "";
      this.EmptyVatNumber = false;
      this.EmptyCompany = false;
      this.canStore = true;
      this.isLoadingStepOne = true;
      var spinner =
        '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ' +
        this.$t("proprietaire_register.loading.step_one");
      $("#step1").html(spinner);
      this.CheckValidateStepOne();
      if (this.canStore) {
        registerProprietaire(this.user)
          .then((response) => {
            $("#step1").text(this.isExistingCustomer ? 'Mettre à jour mon profil' : this.$t("proprietaire_register.step1.buttons.next_step"));
            this.isLoadingStepOne = false;
            const store = useRegisterStore();
            
            // Stocker la réponse de l'API pour utilisation ultérieure
            if (response.data) {
              store.setApiResponse(response.data);
            }
            
            store.setUser(this.user);
            this.user.step = 3;
            this.ShowStep1 = false;
            this.ShowStep2 = true;
          })
          .catch((res) => {
            this.isLoadingStepOne = false;
            this.errorMessage = res.response.data.msg;
            $("#step1").text(this.isExistingCustomer ? 'Mettre à jour mon profil' : this.$t("proprietaire_register.step1.buttons.next_step"));
          });
      }
    },
    CheckValidateStepOne() {
      const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (this.user.civilite == "") {
        this.EmptyCivility = true;
        this.canStore = false;
      }
      if (this.user.lastname == "") {
        this.EmptyLastName = true;
        this.canStore = false;
      }
      if (this.user.firstname == "") {
        this.EmptyFirstName = true;
        this.canStore = false;
      }
      
      if (!this.isExistingCustomer) {
        if (this.user.email == "") {
          this.EmptyEmail = true;
          this.canStore = false;
        } else if (!regexEmail.test(this.user.email)) {
          this.errorValidEmail = this.$t("proprietaire_register.errors.email_invalid");
          this.canStore = false;
        }
        if (this.user.confirm_email == "") {
          this.EmptyConfirmEmail = true;
          this.canStore = false;
        } else if (
          this.user.email != "" &&
          regexEmail.test(this.user.email) &&
          this.user.email != this.user.confirm_email
        ) {
          this.errorConfirmEmail = this.$t("proprietaire_register.errors.email_confirm_mismatch");
          this.canStore = false;
        }
      }
      
      if (this.user.password == "") {
        this.EmptyPassword = true;
        this.canStore = false;
      }
      if (this.user.confirm_password == "") {
        this.EmptyConfirmPassword = true;
        this.canStore = false;
      } else if (this.user.password != "" && this.user.password != this.user.confirm_password) {
        this.errorConfirmPassword = this.$t("proprietaire_register.errors.password_confirm_mismatch");
        this.canStore = false;
      }
      if (this.user.professionnel) {
        if (this.user.numeroTva == "") {
          this.EmptyVatNumber = true;
          this.canStore = false;
        }
        if (this.user.company == "") {
          this.EmptyCompany = true;
          this.canStore = false;
        }
      }
      if (!this.canStore) {
        this.isLoadingStepOne = false;
        $("#step1").text(this.isExistingCustomer ? 'Mettre à jour mon profil' : this.$t("proprietaire_register.step1.buttons.next_step"));
      }
    },
    ValidateRegister() {
      this.errorMessage = "";
      this.EmptyStreet = false;
      this.EmptyCodePostal = false;
      this.EmptyCity = false;
      this.EmptyCountry = false;
      this.EmptyPhone = false;
      this.canRegister = true;
      this.isLoadingStepTwo = true;
      
      // Dernière vérification de synchronisation des emails
      if (this.isExistingCustomer && this.user.email && (!this.user.confirm_email || this.user.confirm_email !== this.user.email)) {
        this.user.confirm_email = this.user.email;
      }
      
      var spinner =
        '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ' +
        this.$t("proprietaire_register.loading.step_two");
      $("#step2").html(spinner);
      this.CheckValidateStepTwo();
      if (this.canRegister) {
        registerProprietaire(this.user)
          .then(() => {
            $("#step2").text(this.isExistingCustomer ? 'Finaliser la mise à jour' : this.$t("proprietaire_register.step2.buttons.validate_registration"));
            this.isLoadingStepTwo = false;
            const store = useRegisterStore();
            store.setUser(this.user);
            if (this.isExistingCustomer) {
              store.completeRegistration(); 
              store.clearRegistrationData();
              this.infoMessage = "Votre profil a été mis à jour avec succès !";
            } else {
              store.completeRegistration(); 
              this.infoMessage = this.$t("proprietaire_register.messages.registration_success");
            }
            
            setTimeout(() => {
              this.infoMessage = "";
              this.$router.push("/login-proprietaire");
            }, 3000);
          })
          .catch((res) => {
            this.isLoadingStepTwo = false;
            this.errorMessage = res.response.data.msg;
            $("#step2").text(this.isExistingCustomer ? 'Finaliser la mise à jour' : this.$t("proprietaire_register.step2.buttons.validate_registration"));
          });
      }
    },
    CheckValidateStepTwo() {
      if (this.user.street == "") {
        this.EmptyStreet = true;
        this.canRegister = false;
      }
      if (this.user.postcode == "") {
        this.EmptyCodePostal = true;
        this.canRegister = false;
      }
      if (this.user.city == "") {
        this.EmptyCity = true;
        this.canRegister = false;
      }
      if (this.user.countrycode == "") {
        this.EmptyCountry = true;
        this.canRegister = false;
      }
      if (this.user.phonenumber == "") {
        this.EmptyPhone = true;
        this.canRegister = false;
      }
      if (!this.canRegister) {
        this.isLoadingStepTwo = false;
        $("#step2").text(this.isExistingCustomer ? 'Finaliser la mise à jour' : this.$t("proprietaire_register.step2.buttons.validate_registration"));
      }
    },
  },
  beforeUnmount() {
    const store = useRegisterStore();
    // Nettoyer les données sensibles quand le composant est détruit
    store.clearSensitiveData();
  },
};
</script>
<style scoped>
  .register-body {
    position: relative;
    height: 100%;
  }
  .top-logo {
    text-align: end;
  }
  .top-logo img {
    margin-right: 20px;
  }

  .register-body .title {
    color: #1e347d;
    font-size: 22px;
    font-weight: bold;
    line-height: 29px;
    position: relative;
    left: 13%;
  }
  .register-body .slogan {
    font-size: 17px;
    color: #1e347d;
    text-align: center;
  }
  .cards-login {
    justify-content: center;
  }
  .card-login .title {
    color: #1e347d;
    font-size: 23px;
    font-weight: bold;
  }
  .register-body .icon-wrapper {
    padding-top: 30px;
    padding-bottom: 30px;
    margin: 0 auto;
    border: 2px solid #1e347d;
    border-radius: 10px;
  }
  .register-body .icon-wrapper.selected {
    background: #c9cfde 0% 0% no-repeat padding-box;
  }
  .register-body .checked-card {
    width: 17px;
    height: 17px;
    border: 2px solid #1e347d;
    color: #1e347d;
    padding: 2px 2px 2px 0px;
    font-size: 20px;
    position: absolute;
    left: 75%;
    top: 5%;
    line-height: 15px;
  }
  .form-register {
    .input-text {
      height: 40px;
      background: #ffffff 0% 0% no-repeat padding-box;
      border: 2px solid #aeb1ba;
      border-radius: 76px;
      padding: 0 20px;
      transition: all 0.3s ease-in-out;
    }
    .input-text:focus {
      border-color: #c9cfde;
      box-shadow: 0 0 8px #c9cfde;
      transform: scale(1.05);
      outline: none;
    }
    
    /* Style pour l'email désactivé */
    .email-disabled {
      background-color: #f8f9fa !important;
      border-color: #dee2e6 !important;
      color: #6c757d !important;
      cursor: not-allowed !important;
      opacity: 0.8;
    }
    
    .dropdown-toggle {
      height: 40px;
      border: 2px solid #aeb1ba;
      background: #ffffff 0% 0% no-repeat padding-box;
      border-radius: 76px;
      padding: 0 20px;
      transition: all 0.3s ease-in-out;
    }
    .dropdown-toggle:focus {
      border-color: #c9cfde;
      box-shadow: 0 0 8px #c9cfde;
      transform: scale(1.05);
      outline: none;
    }
    .dropdown-toggle::after {
      margin-left: 27em;
    }
  }
  
  .email-lock-info {
    position: absolute;
    top: -20px;
    left: 15px;
    font-size: 0.8rem;
  }
  
  .password-info {
    background-color: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 10px;
    padding: 10px 15px;
    color: #856404;
    font-size: 14px;
  }
  
  .alert-info {
    background-color: #e7f3ff;
    border: 1px solid #b3d7ff;
    border-radius: 10px;
    padding: 12px 15px;
    color: #004085;
    font-size: 14px;
  }
  
  .alert-warning {
    background-color: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 10px;
    padding: 12px 15px;
    color: #856404;
    font-size: 14px;
  }

  .btn-register {
    background-color: #ec621a !important;
    border-radius: 76px;
    font-size: 19px;
    text-align: center;
    font: normal normal bold 19px/25px DM Sans;
    letter-spacing: 0px;
  }
  .prev-step {
    font-size: 16px;
    color: #1e347d;
    margin-left: 30px;
    font-weight: bold;
    cursor: pointer;
  }
  .info-prop {
    background: #c9cfde 0% 0% no-repeat padding-box;
    padding: 14px;
    border-radius: 10px;
    color: #1e347d;
  }
  .error {
    border-color: red !important;
  }
  .alert {
    border-radius: 4px;
    color: #515a6e;
    font-size: 18px;
    line-height: 16px;
    margin-bottom: 10px;
    position: relative;
  }
  .error-message {
    color: red;
    margin-left: 8px;
  }
  .alert-success {
    background-color: #edfff3;
    border: 1px solid #8ce6b0;
  }
  .info-message {
    margin-left: 8px;
  }

  /* Style pour le champ de confirmation d'email désactivé */
  input[disabled] {
    background-color: #f8f9fa !important;
    border-color: #dee2e6 !important;
    color: #6c757d !important;
  }
</style>